import React from 'react';
import { Mask, Button, Alert, Text, View } from '@instructure/ui';
import { IconResetLine } from '@smarterservices/smarter-ui';
import { getStore } from '../../../stores/StoreContext';

const PlaybackComplete = () => {
  const PlayerStore = getStore('playerStore');
  const SessionStore = getStore('examSessionStore');

  return (
    
      <Mask
        placement="center"
        themeOverride={{
          borderRadius: '0rem',
          zIndex: 7000
        }}
      >
        
        <Button
          onClick={() => PlayerStore.jumpTo(0)}
          renderIcon={IconResetLine}
          withBackground={false}
          color="primary"
          margin="small"
        >
          Restart
        </Button>

        {SessionStore.childSessionData && (
          <View as="div" width="80%" margin="medium auto">
          <Alert
          variant="info"
          margin="x-small 0"
          
          hasShadow={false}
        >
          <Text size='small' as="p">
            This session ended in a {SessionStore.sessionData.status} status. There is 
            a subsequent video session that is associated with this attempt. Watch that session by clicking the "Next Session" button.
          </Text>
          <Button
            size="small"
            withBackground={false}
            color="primary"
            margin="small"
          >
            View Next Video
          </Button>
        </Alert>
          
          
          </View>
        )}


      </Mask>
  );
};

export default PlaybackComplete;
